export default __webpack_public_path__ + "b65534c52236842619456e68aeced3ca.woff2";